import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const Malasya = () => {
    return <SharedDocumentsComponent permissionId="42" path="Malásia" />
}